export function updHeroSlider() {
    let $hero = $(".updated-hero-section");
    let $mediaSlider = $(".hero-media-slider");
    let $navSlider = $(".hero-slider-nav");
    let customAutoplaySpeed = $navSlider.attr("data-autoplay-speed");
    let indicators = $navSlider.find("circle");
    let $containersHasMp4 = $("[data-video-src]");

    let createVideo = function (element) {
        let videoSrc = $(element).attr("data-video-src");
        let posterSrc = $(element).attr("data-poster-src");

        let video = $("<video class='video' preload='metadata' autoplay muted playsinline loop poster='" + posterSrc + "'><source src='" + videoSrc + "' type='video/mp4'></video>");

        $(element).append(video);
    };

    if (!customAutoplaySpeed) {
        customAutoplaySpeed = 7000; // default speed
    }

    if (String(customAutoplaySpeed).length <= 2 ) {
        customAutoplaySpeed = customAutoplaySpeed + "000";
    }

    if (customAutoplaySpeed) {

        for (let i = 0; i < indicators.length; i++) {
            $(indicators[i]).css({
                transition: "stroke-dashoffset " + customAutoplaySpeed + "ms linear .3s",
            });
        }
    }

    $mediaSlider.slick({
        slidesToShow: 1,
        slidesToSlide: 1,
        fade: true,
        dots: false,
        arrows: false,
        asNavFor: $navSlider,
    });

    $navSlider.on("init", function (event, slick) {
        slick.slickGoTo(0);
    });

    $navSlider.slick({
        slidesToShow: 4,
        slidesToSlide: 1,
        dots: false,
        arrows: true,
        speed: 300,
        focusOnSelect: true,
        autoplay: true,
        autoplaySpeed: Number(customAutoplaySpeed),
        asNavFor: $mediaSlider,
        pauseOnFocus: false,
        pauseOnHover: false,
        initialSlide: 2,
        nextArrow: `<button class="next" title="next button"><svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 9H19M19 9L10.6875 1M19 9L10.6875 17" stroke="#221C35" stroke-width="2"/>
                    </svg></button>`,
        prevArrow: `<button class="prev" title="prev button"><svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 9H19M19 9L10.6875 1M19 9L10.6875 17" stroke="#221C35" stroke-width="2"/>
                    </svg></button>`,
    });

    $(document).ready( function () {
        $hero.addClass("animate");
    });

    $(window).on("load", function () {

        if (!$mediaSlider.hasClass("loaded") && $(window).width() >= 1024) {
            $containersHasMp4.each( function () {
                if ($(this).closest(".slick-current")) {
                    createVideo(this);
                }
            }); 

            $mediaSlider.addClass("loaded");
        }

        // let $banner = $("#intercom-container");

        // if ($banner && $banner.length) {
        //     let $iframeName = $banner.find("iframe").attr("name");

        //     if ($iframeName === "intercom-banner-frame") {

        //     }
        // }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/updHeroSlider.js